<template>
  <v-container fluid class="container-full-bg-gray">  
  {{message}} 
  </v-container>
</template>
<script>
import { client, setHeaders } from "../../../api/client";
import { mapActions } from "vuex"

export default {
  name: 'LoginToken',
  props: {
    token: {
      type: String,
      required: false,
      default: '',
    },
    company_id: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {   
      message:'redirecting...'
    }
  },
  
  async mounted() {   
    
    if(this.token){
      setHeaders({})
      let res = await client.post('invalidate_one_time_token/'+this.token+'/',{})
      console.log(res)
      if('error' in res.data)
          this.message = res.data.error
      else
          this.login(res.data.username,res.data.password)
    }
    else{
      let isLogged = await this.waitForLoggedIn();
      if(isLogged){
        this.resetCurrentCompany({new_company: {'id':this.company_id}});
        this.$router.push({name: 'invoice-list', params: { companydb_id: this.company_id}});
      }
      else{
        this.message='not logged'
        // window.location.href='http://www.google.com'
      }
    }
          
  },
  methods: {
    async login(username,password) {
        const result = await this.signInUser({
            username: username,
            password: password
        });
        this.setJWTToken(result);
        this.setAfterLogged().then(() => {
          this.resetCurrentCompany({new_company: {'id':this.company_id}});
          this.$router.push({name: 'invoice-list', params: { companydb_id: this.company_id}});
        })
        },
        ...mapActions(["signInUser", "setJWTToken", "setAfterLogged", "waitForLoggedIn","resetCurrentCompany"]),


  }
}
</script> 

<style scoped>
  .container-full-bg-gray {
    height: 100%;
    background-color: var(--v-background-base);
  }
</style>